<template>
    <router-link v-if="field === 'title'" :to="{ name: 'tasks.show', params: { slug: item.id }, query: {project_id: this.projectId} }" class="title-column">
        {{ $filters.valueOrDefault(item.title ) }}
    </router-link>

    <router-link v-else-if="field === 'last_editor_id'" :to="{ name: 'users.show', params: { slug: item.last_editor_id } }">
        {{ userNameById(item.last_editor_id) }}
    </router-link>

    <div v-else-if="field === 'description'" v-html="$filters.valueOrDefault(item.description, '-')" class="description-column"></div>
    <span v-else-if="field === 'location'">{{ $filters.valueOrDefault(item.location_name ) }}</span>
    <dropdown-quick-edit v-else-if="field === 'status'" :entity="item" field="status" :update="partialUpdateTask" :options="taskStatuses"/>
    <span v-else-if="field === 'is_external'">{{ $filters.yesNo(item.is_external ) }}</span>
    <span v-else-if="field === 'is_milestone'">{{ $filters.yesNo(item.is_milestone ) }}</span>
    <span v-else-if="field === 'is_package_log'">{{ $filters.yesNo(item.is_package_log ) }}</span>
    <span v-else-if="field === 'due_date'">{{   $filters.valueOrDefault($filters.date(item.due_date)) }}</span>
    <span v-else-if="field === 'date_requested'">{{  $filters.valueOrDefault($filters.date(item.date_requested )) }}</span>
    <span v-else-if="field === 'date_sent'">{{  $filters.valueOrDefault($filters.date(item.date_sent )) }}</span>
    <span v-else-if="field === 'date_received'">{{  $filters.valueOrDefault($filters.date(item.date_received )) }}</span>
    <span v-else-if="field === 'contact_id'">{{ $filters.valueOrDefault(item.contact_name ,'–') }}</span>
    <span v-else-if="field === 'category_id'">{{  $filters.valueOrDefault(categoryNameById(item.category_id),'–') }}</span>
    <div v-else-if="field  === 'latest_note'" v-html="latestNoteMessageByTaskId(item.id)"></div>
    <span v-else-if="field === 'created_at'">{{ $filters.datetime(item.created_at ) }}</span>
    <span v-else-if="field === 'updated_at'">{{ $filters.datetime(item.updated_at ) }}</span>
    <span v-else-if="field === 'date_completed'">{{ $filters.valueOrDefault($filters.date(item.date_completed ) ) }}</span>
    <span v-else-if="field === 'date_created'">{{ $filters.valueOrDefault($filters.date(item.date_created ) ) }}</span>

    <router-link v-else-if="field === 'application_id'" :to="applicationRoute(item)">
        {{ applicationNameByTypeAndId(item.application_type, item.application_id) }}
    </router-link>

    <router-link v-else-if="field === 'assignee_id'" :to="{ name: 'users.show', params: { slug: item.assignee_id } }">
        {{ $filters.valueOrDefault(userNameById(item.assignee_id),'–') }}
    </router-link>

    <router-link v-else-if="field === 'creator_id'" :to="{ name: 'users.show', params: { slug: item.creator_id } }">
        {{ $filters.valueOrDefault(userNameById(item.creator_id),'–') }}
    </router-link>

    <span v-else-if="field === 'project_id'">
        <span v-if="$route.name == 'projects.show.tasks' && $route.params.slug == item.project_id">
            {{ projectNameById(item.project_id) }}
        </span>

        <router-link v-else :to="{ name: 'projects.show', params: { slug: item.project_id } }">
            {{ projectNameById(item.project_id) }}
        </router-link>
    </span>
    <span v-else-if="field === 'project_service_id'">
        <span >
            {{ projectServiceNameById(item.project_service_id) }}
        </span>
    </span>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    
    export default {
        props: ['item', 'field', 'projectId'],
    
        computed: {
            ...mapGetters([
                'applicationNameByTypeAndId',
                'latestNoteMessageByTaskId',
                'categoryNameById',
                'projectNameById',
                'taskStatuses',
                'userNameById',
                'projectServiceNameById'
            ]),

            applicationRoute() {
                return (task) => {
                    return {
                        name: 'projects.show.applications',
                        params: {
                            applicationTypeParam: task.application_type,
                            applicationIdParam: task.application_id,
                            slug: task.project_id
                        }
                    }
                }
            }
        },

        methods: {
            ...mapActions(['partialUpdateTask'])
        }
    }
</script>
